import { CheckoutSession } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { EditConfirmAlert } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/components/EditConfirmAlert';
import { useSubmitDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useSubmitDialog';
import { EditDownPayment } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/components/EditDownPayment';
import { useEditDownPayment } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/hooks/useEditDownPayment';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';

interface EditCheckoutSessionDownPaymentDialogProps {
  checkoutSession: CheckoutSession;
  opened: boolean;
  setOpened: (opened: boolean) => void;
}

export const EditCheckoutSessionDownPaymentDialog = ({
  checkoutSession,
  opened,
  setOpened,
}: EditCheckoutSessionDownPaymentDialogProps) => {
  const { openedConfirmAlert, setOpenedConfirmAlert, handleSubmit, handleClose } = useSubmitDialog({ setOpened });
  const { editDownPayment, loading: loadingEditDownPayment } = useEditDownPayment(checkoutSession);

  const [newDownPaymentValue, setNewDownPaymentValue] = useState<number>(checkoutSession.downPayment?.amount.amount);

  return (
    <NemuruDialog
      opened={opened}
      setOpened={setOpened}
      hideButtonsWrapper
      dialogProps={{
        maxWidth: 'sm',
      }}
      onClose={() => handleClose()}
    >
      <EditDownPayment
        checkoutSession={checkoutSession}
        newDownPaymentValue={newDownPaymentValue}
        setNewDownPaymentValue={setNewDownPaymentValue}
        onComplete={() => setOpenedConfirmAlert(true)}
        onCancel={() => handleClose()}
      />
      <EditConfirmAlert
        opened={openedConfirmAlert}
        setOpened={setOpenedConfirmAlert}
        onSubmit={() => handleSubmit(async () => await editDownPayment(newDownPaymentValue))}
        loading={loadingEditDownPayment}
      />
    </NemuruDialog>
  );
};
